import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';


export const getCatalogApiRequestById = async (catalogApiRequestId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/sap/catalog_api_request/${catalogApiRequestId}`);
        return await response.data;
    } catch (error) {
        console.log("getCatalogApiRequestById: - error", error)
        return handleApiError(error)
    }
}

export const updateCatalogApiRequest = async (catalogApiRequestId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/sap/update/catalog_api_request/${catalogApiRequestId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateCatalogApiRequest: - error", error)
        return handleApiError(error)
    }
}

export const addCatelogueRequest = async(data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/sap/requirement`, data)
        return await response.data;
    } catch (error) {
        console.log("addCatelogueRequest - error", error)
        return handleApiError(error)
    }
}

export const insertAribaReqItems = async(data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/sap/ariba-req-items`, data)
        return await response.data;
    } catch (error) {
        console.log("insertAribaReqItems - error", error)
        return handleApiError(error)
    }
}

export const getAribaReqItems = async(catalogRequestId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/sap/ariba-req-items/${catalogRequestId}`)
        return await response.data;
    } catch (error) {
        console.log("getAribaReqItems - error", error)
        return handleApiError(error)
    }
}

export const placeSAPOrder = async(data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/sap/`, data)
        return await response.data;
    } catch (error) {
        console.log("placeSAPOrder - error", error)
        return handleApiError(error)
    }
}